import { render, staticRenderFns } from "./V2ProfileMenu.vue?vue&type=template&id=4dc6e805&scoped=true&"
import script from "./V2ProfileMenu.vue?vue&type=script&lang=js&"
export * from "./V2ProfileMenu.vue?vue&type=script&lang=js&"
import style0 from "./V2ProfileMenu.vue?vue&type=style&index=0&id=4dc6e805&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc6e805",
  null
  
)

export default component.exports